import axios from 'axios'
import { Toast } from 'vant'
import qs from 'qs'
import { clearUserInfo, getUserInfo } from './login'
let userInfo = null

const http = (method, postType, path, data, isCatch) => {
    return new Promise((resolve, reject) => {
        const SEVER_PATH = window.SEVER_DEFAULT_PATH
        if (!userInfo) {
            userInfo = getUserInfo()
        }
        const headers = {
            channel: 'h5',
            ['content-Type']: 'application/json',
        }
        if (userInfo) {
            headers['token'] = userInfo.token
        }
        if (postType === 'form') {
            headers['content-Type'] = 'application/x-www-form-urlencoded'
        }
        const params = postType === 'form' ? qs.stringify(data) : data

        axios({
            method,
            url: SEVER_PATH + path,
            headers: headers,
            data: params,
            withCredentials: true,
        })
            .then((res) => {
                if (res.status == 200 && res.data.code === 200) {
                    resolve(res.data)
                } else if (res.data.code === 401) {
                    clearUserInfo()
                    window.location.reload()
                } else {
                    if (isCatch) {
                        reject(res)
                    }
                    Toast(res.data.message)
                }
            })
            .catch((err) => {
                if (isCatch) {
                    reject(err)
                }
                Toast(JSON.stringify(err))
            })
    })
}

const begonia_post = function (url, data, isCatch) {
    return http('POST', '', '/begonia-api' + url, data, isCatch)
}

const begonia_post_form = function (url, data, isCatch) {
    return http('POST', 'form', '/begonia-api' + url, data, isCatch)
}

const material_post = function (url, data, isCatch) {
    return http('POST', '', '/material-api' + url, data, isCatch)
}

const material_post_form = function (url, data, isCatch) {
    return http('POST', 'form', '/material-api' + url, data, isCatch)
}

const nuwa_post = function (url, data, isCatch) {
    return http('POST', '', '/nuwa-api' + url, data, isCatch)
}

const nuwa_post_form = function (url, data, isCatch) {
    return http('POST', 'form', '/nuwa-api' + url, data, isCatch)
}

const cupid_post = (url, data, isCatch) => {
    return http('POST', '', '/cupid-api' + url, data, isCatch)
}

const hunter_post = (url, data, isCatch) => {
    return http('POST', '', '/hunter-api' + url, data, isCatch)
}
// const hunter_post_form = function (url, data, isCatch) {
//     return http('POST', 'form', '/hunter-api' + url, data, isCatch)
// }

export const getMaterialShareState = function (data) {
    return material_post_form('/materialShare/get', data, true)
}

export const getMaterialShareFiles = function (data) {
    return material_post('/materialShare/files', data)
}

export const previewMaterialFile = function (data) {
    return material_post('/materialFile/preview', data)
}

export const downloadMaterialFile = function (data) {
    return material_post('/materialFile/download', data)
}

export const getExamResultSubjects = function () {
    return begonia_post_form('/officialExamResult/subjects', {})
}

export const getArticleList = (data) => {
    return nuwa_post('/vocabArticle/list?ver=1', data)
}

export const exchangeGift = (data) => {
    return begonia_post('/plugin/exchange', data)
}

export const getGiftInfo = function (data) {
    return begonia_post('/plugin/giftInfo', data)
}

export const getAliyunOssToken = function (data) {
    return begonia_post_form('/aliyun/getOssToken', data)
}

export const addCashback = function (data) {
    return begonia_post('/activity/cashback/add', data)
}

export const modCashback = function (data) {
    return begonia_post('/activity/cashback/mod', data)
}

export const getCashbackList = function (data) {
    return begonia_post('/activity/cashback/list', data)
}

export const getLiveCourseList = (data) => {
    return nuwa_post_form('/course/live', data)
}

export const getFileDownloadUrl = (data) => {
    return cupid_post('/aliyun/oss/privateUrl', data)
}

export const coursePackageUserList = (data) => {
    return nuwa_post_form('/coursePackageUser/list', data)
}

export const getAgreementStates = (data) => {
    return begonia_post('/trade/getAgreementStates', data)
}
export const signAgreement = (data) => {
    return begonia_post_form('/trade/signAgreement', data)
}

export const complainFeedbackStatus = (data) => {
    return nuwa_post('/app/complain/feedback/status', data)
}

export const saveComplainFeedback = (data) => {
    return nuwa_post('/app/complain/feedback/save', data, true)
}

// 获取小程序码
export const getQrcodeRedirect = (data) => {
    return hunter_post('/qrcode/redirect', data)
}
// 获取销售接量码
export const getStaffQrcode = (data) => {
    return hunter_post('/xbTrack/activeWechat', data)
}

export const xbTrackActive = (data) => {
    return hunter_post('/xbTrack/active', data, true)
}


export const saveSchoolInfo = (data) => {
    return begonia_post('/plugin/qrcode/active', data)
}

export const getSchoolList = (data) => {
    return hunter_post('/xbTrack/school/list', data)
}


export const addUserAttend = function (data) {
    return nuwa_post('/course/addUserAttend', data, false)
}
